// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_FILTER_MODAL_CLOSE = "Zav\u0159\u00edt";
export const BZ_CATEGORY_TYPE_LABEL_FOR_CHILDREN = "Pro d\u011bti";
